import { render, staticRenderFns } from "./DragDropPage.vue?vue&type=template&id=353fd483&scoped=true&lang=html"
import script from "./DragDropPage.vue?vue&type=script&lang=js"
export * from "./DragDropPage.vue?vue&type=script&lang=js"
import style0 from "./DragDropPage.vue?vue&type=style&index=0&id=353fd483&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fd483",
  null
  
)

export default component.exports